<template>
  <div class="card-zoom" :class="`${color} ${customClass}`">
    <slot />
  </div>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: 'top-left-yellow',
  },
  customClass: String,
});
</script>

<style scoped></style>
